import { combineReducers } from "redux";
import getSnapshotsListReducer from "./getSnapshotsListReducer";

const SnapshotsListReducer = combineReducers({
    SnapshotsList: getSnapshotsListReducer

});

export default SnapshotsListReducer;
